import { SearchStats } from "./SearchStats";
import { ExportButton } from "@/components/search/ExportButton";
import { Product } from "@/types/product";

interface StatsSectionProps {
  products: Product[];
}

export const StatsSection = ({ products }: StatsSectionProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <SearchStats totalResults={products.length} />
      <ExportButton suggestions={products} query="filtered-data" />
    </div>
  );
};